<template>

    <div class="container">

        <app-head title="Manufacturers" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Manufacturers') }}</h1>
            <div class="">
                <inertia-link class="btn btn-primary" :href="route('admin.manufacturers.create')">
                    {{ __('Create') }}
                </inertia-link>
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
                <select-input label="Status" v-model="form.status">
                    <option :value="null">{{ __('Veröffentlicht') }}</option>
                    <option value="trashed">{{ __('Papierkorb') }}</option>
                </select-input>
                <select-input label="aliasization" v-model="form.aliasization">
                    <option :value="null">{{ __('Alle') }}</option>
                    <option value="no_aliases">{{ __('No aliases') }}</option>
                    <option value="only_aliased">{{ __('Only aliased') }}</option>
                    <option value="only_aliases">{{ __('Only aliases') }}</option>
                </select-input>
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="manufacturers.meta" />
        </div>

        <div class="card">
            <data-table :items="manufacturers.data"
                        :links="manufacturers.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="manufacturer in manufacturers.data" :key="manufacturer.id">
                    <td>
                        {{ manufacturer.id }}
                    </td>
                    <td>
                        <!--@todo was beachten bei alias/aliased löschen?-->
                        <div v-if="manufacturer.deleted_at">
                            {{ manufacturer.name }}
                        </div>
                        <inertia-link :class="{'opacity-50': manufacturer.aliased}" :href="route('admin.manufacturers.edit', manufacturer)">
                            {{ manufacturer.name }}
                        </inertia-link>
                        <a :href="'https://www.google.com/search?q=' + manufacturer.name" target="_blank" class="small link-secondary">
                            [{{ __('Google') }}]
                        </a>
                    </td>
                    <td>
                        {{ manufacturer.aliases_count || '-' }}
                    </td>
                    <td>
                        <template class="" v-if="manufacturer.aliased">
                            <inertia-link class="" :href="route('admin.manufacturers.edit', manufacturer.aliased)">
                                {{ manufacturer.aliased.name }}
                            </inertia-link>
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td>
                        <div class="small" v-if="manufacturer.alias_suggestions.length">
                            <div v-for="suggestion in manufacturer.alias_suggestions">
                                <inertia-link :href="route('admin.manufacturers.edit', {manufacturer: suggestion, aliased_id: manufacturer.id})">
                                    {{ suggestion.name }}
                                </inertia-link>
                                <a :href="'https://www.google.com/search?q=' + suggestion.name" target="_blank" class="small link-secondary">
                                    [{{ __('Google') }}]
                                </a>
                            </div>
                        </div>
                        <div v-else>-</div>
                    </td>
                    <td>
                        <inertia-link class="" :href="route('admin.products.index', {manufacturer_id: manufacturer.id})">
                            {{ manufacturer.number_products || 0 | localizeNumber }}
                        </inertia-link>
                    </td>
                    <td>
                        {{ manufacturer.description || '-' | truncateWords }}
                    </td>
                    <td class="text-end">
                        <template v-if="manufacturer.deleted_at">
                            <button type="button" class="btn btn-outline-success" @click="restore(manufacturer)">
                                {{ __('Restore') }}
                            </button>
                            <button type="button" class="btn btn-outline-danger" @click="destroyPermanently(manufacturer)">
                                {{ __('Destroy permanently') }}
                            </button>
                        </template>
                        <template v-else>
                            <i class="bi bi-chevron-right"></i>
                        </template>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';

    import SelectInput from '@/shared/Inputs/SelectInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';

    import Results from '@/shared/Admin/Results';

    export default {
        props: [
            'filters',
            'manufacturers',
        ],
        components: {
            DataTable,
            DataTableRow,
            SearchFilter,
            SelectInput,
            CheckboxInput,
            Results,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                    status: this.filters.status,
                    aliasization: this.filters.aliasization,
                },
                columns: {
                    id: {label: 'ID', sortable: 'id'},
                    name: {label: 'Name', sortable: 'name'},
                    aliases_count: {label: 'Aliases', sortable: 'aliases_count'},
                    aliased: {label: 'Alias von'},
                    alias_suggestions: {label: 'Alias suggestions'},
                    number_products: {label: 'Products', sortable: 'number_products'},
                    description: {label: 'Description'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.manufacturers.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
            destroyPermanently(manufacturer) {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('admin.manufacturers.destroy-permanently', manufacturer.id));
                }
            },
            restore(manufacturer) {
                this.$inertia.get(this.route('admin.manufacturers.restore', manufacturer.id));
            },
        },
    }
</script>